import Head from "next/head";
import { Fragment } from "react";
import { MetaDetails } from "./MetaDetails";
import { useRouteParams } from "@/hooks/useRouteParams";
import { PageProps } from "@/getServerSideProps/getServerSideProps";

export function Meta({
  productListingData,
  flags,
}: Pick<PageProps, "productListingData" | "flags">) {
  const { endecaCanonical, pageInformation, pagesAvailable } =
    productListingData;

  const route = useRouteParams();
  const { pageType, query } = route;

  const currentPage = parseInt(
    (Array.isArray(query.page) ? query.page[0] : query.page) || "1",
  );
  const currentPageText = `?page=${query.page || "1"}`;
  const prevPageText = `?page=${currentPage - 1}`;
  const nextPageText = `?page=${currentPage + 1}`;

  const canonicalPath = endecaCanonical
    ? `/${pageType}/${endecaCanonical.replace(/^\//, "")}`
    : "";
  const canonical = `https://www.johnlewis.com${canonicalPath}`;

  const currentPageCanonical = `${canonical}${
    currentPage > 1 ? currentPageText : ""
  }`;

  return (
    <Head>
      <title key="metaTitle">{pageInformation.title}</title>
      <MetaDetails
        currentPageCanonical={currentPageCanonical}
        productListingData={productListingData}
        route={route}
        flags={flags}
      />
      {pageType !== "search" && (
        <Fragment>
          <link
            key="metaCanonical"
            rel="canonical"
            href={currentPageCanonical}
          />
          {currentPage < (pagesAvailable || 1) && (
            <link
              key="metaNext"
              rel="next"
              href={`${canonical}${nextPageText}`}
            />
          )}
          {currentPage > 1 && (
            <link
              key="metaPrev"
              rel="prev"
              href={`${canonical}${currentPage > 2 ? `${prevPageText}` : ""}`}
            />
          )}
        </Fragment>
      )}
    </Head>
  );
}
